// @ts-nocheck
import { styled } from '@mui/material/styles';
import './documentSheet.css';
// Legacy table styling (.style1/.style2/.style3) the stored doc content relies
// on — keep it loaded wherever a document sheet renders.
import '../../pages/documents/TableStyle.css';

// One document sheet rendering stored HTML. Theme-aware: it inherits the theme
// paper background and text colour so the content (which carries its own inline
// colours, authored for the app theme) stays readable in light and dark mode.
// When `onClick` is provided the sheet becomes a click-to-edit button.

const Sheet = styled('div', {
  shouldForwardProp: (p) => p !== 'clickable',
})(({ theme, clickable }) => ({
  position: 'relative',
  background: theme.palette.background.paper,
  color: theme.palette.text.primary,
  width: '100%',
  maxWidth: 794, // ~A4 width at 96dpi
  margin: '0 auto 20px',
  padding: '40px 48px',
  borderRadius: Number(theme.shape.borderRadius) * 1.5,
  border: `1px solid ${theme.palette.divider}`,
  boxShadow:
    theme.palette.mode === 'light'
      ? '0 1px 2px rgba(16,24,40,0.06), 0 8px 24px rgba(16,24,40,0.06)'
      : '0 1px 2px rgba(0,0,0,0.4), 0 8px 24px rgba(0,0,0,0.4)',
  transition: theme.transitions.create(['box-shadow', 'border-color', 'transform']),
  ...(clickable && {
    cursor: 'pointer',
    '&:hover': {
      borderColor: theme.palette.primary.main,
      boxShadow:
        theme.palette.mode === 'light'
          ? '0 1px 2px rgba(16,24,40,0.08), 0 12px 32px rgba(16,24,40,0.12)'
          : '0 1px 2px rgba(0,0,0,0.5), 0 12px 32px rgba(0,0,0,0.55)',
    },
    '&:active': { transform: 'translateY(1px)' },
  }),
}));

// Wrap {{Token}} occurrences so the editor preview highlights unfilled
// placeholders. Tokens live in text nodes, so this string transform is safe.
export function highlightDocTokens(html) {
  if (!html) return '';
  return String(html).replace(
    /\{\{\s*([A-Za-z][\w]*)\s*\}\}/g,
    '<span class="doc-token">{{$1}}</span>',
  );
}

const HeaderBar = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  marginBottom: 24,
  paddingBottom: 16,
  borderBottom: `1px solid ${theme.palette.divider}`,
}));

const FooterBar = styled('div')(({ theme }) => ({
  marginTop: 24,
  paddingTop: 12,
  borderTop: `1px solid ${theme.palette.divider}`,
  color: theme.palette.text.disabled,
  fontSize: 11,
  textAlign: 'center',
}));

export default function DocumentSheet({
  html,
  highlight = true,
  onClick,
  header,
  footer,
  sx,
  children,
}) {
  const inner = highlight ? highlightDocTokens(html) : html || '';
  return (
    <Sheet
      clickable={Boolean(onClick)}
      onClick={onClick}
      role={onClick ? 'button' : undefined}
      tabIndex={onClick ? 0 : undefined}
      onKeyDown={onClick ? (e) => (e.key === 'Enter' || e.key === ' ') && onClick(e) : undefined}
      sx={sx}
    >
      {header && <HeaderBar>{header}</HeaderBar>}
      {inner && <div className="wesafe-doc safetyDoc" dangerouslySetInnerHTML={{ __html: inner }} />}
      {children}
      {footer && <FooterBar>{footer}</FooterBar>}
    </Sheet>
  );
}
